export function deltaDate(
  input: Date,
  { days = 0, months = 0, years = 0 }: { days?: number; months?: number; years?: number }
): Date {
  return new Date(
    input.getFullYear() + years,
    input.getMonth() + months,
    Math.min(
      input.getDate() + days,
      new Date(
        input.getFullYear() + years,
        input.getMonth() + months + 1,
        0
      ).getDate()
    )
  );
}
